import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setLoginState } from "store/reducers/app";
import { setUserData } from "store/reducers/app";
import { store } from "store/store";
// import { refreshToken } from "./apiTokenController";
import { API_ENDPOINTS } from "utils";
import { api } from "utils";
import { isEmpty } from "lodash";
import { handleError } from "utils/handleError";
import Translation from "components/common/translations";

// let refreshTokenInterval;

const AuthController = {};

const validate = (data) => {
  const { username, password } = data;
  let result = true;
  if (isEmpty(username)) {
    result = false;
    toast.warning(<Translation label="_enterEmailLogin" />);
  }
  if (isEmpty(password)) {
    result = false;
    toast.warning(<Translation label="_enterPasswordLogin" />);
  }
  return result;
};

AuthController.login = async (username, password) => {
  const body = {
    username,
    password,
  };
  if (!validate(body)) {
    return; // do not continue if not valid input
  }

  try {
    let currentLanguage = localStorage.getItem("langId");
    if (currentLanguage === "US") {
      currentLanguage = "EN";
    }
    const response = await api.post(API_ENDPOINTS.LOGIN, body, {
      headers: {
        "Accept-Language": currentLanguage,
      },
    });

    if (response.status !== 200) {
      throw new Error(response.message || "Login failed. Please try again.");
    }

    return response.data;
  } catch (err) {
    handleError(err);
  }
};

AuthController.logout = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    const body = { refresh_token: refreshToken };

    const response = await api.post(API_ENDPOINTS.LOGOUT, body);

    if (response.status !== 205) {
      throw new Error("Logout failed");
    }

    try {
        const fcm_token = localStorage.getItem("fcm_token");
        console.log('withjin logout the fcm_token is: ', fcm_token)
        if (!isEmpty(fcm_token)) {
          await deleteFCMToken(fcm_token);
          // TODO - consider doing this without await
          // TODO - verify no errors of this request (for unsupported browsers)
        }
    } catch (error) {
        // console.error("Notification token error:", error);
    }

    AuthController.localLogout();
  } catch (error) {
    handleError(error);
  }
};

AuthController.localLogout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("userData");

  AuthController.setLoginStatus(false);
  store.dispatch(setLoginState(false));
  store.dispatch(setUserData(null));

  window.location.href = "/login";
};

// This function is temporary, it is for navigate to register page
AuthController.localLogoutNavReg = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("userData");

  AuthController.setLoginStatus(false);
  store.dispatch(setLoginState(false));
  store.dispatch(setUserData(null));

  window.location.href = "/register";
};

AuthController.confirm = async (email, verificationCode) => {
  try {
    const body = {
      email,
      code: verificationCode,
    };
    const response = await api.post(API_ENDPOINTS.VERIFY_2FA, body);

    if (response.status === 200) {
      localStorage.setItem("access_token", response.data.access_token);
      localStorage.setItem("refresh_token", response.data.refresh_token);

      AuthController.setLoginStatus(true);
      store.dispatch(setLoginState(true));

      try {
          const fcm_token = localStorage.getItem("fcm_token");
          if (!isEmpty(fcm_token)) {
            await addFCMToken(fcm_token);
            // TODO - consider doing this without await
            // TODO - verify no errors of this request (for unsupported browsers)
          }
      } catch (error) {
          // console.error("Notification token error:", error);
      }

      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

AuthController.isUserLoggedIn = () => {
  const access_token = localStorage.getItem("access_token");
  const refresh_token = localStorage.getItem("refresh_token");

  return !!(access_token && refresh_token);
};

AuthController.setLoginStatus = (isLoggedIn) => {
  localStorage.setItem("isLoggedIn", isLoggedIn);
};

AuthController.resendCode = async (email) => {
  try {
    const body = { email };
    const response = await api.post(API_ENDPOINTS.RESEND_LOGIN, body);

    if (response.status === 200) {
      toast.success("Verification code resent successfully.");
    } else {
      throw new Error("Failed to resend verification code.");
    }
  } catch (error) {
    handleError(error);
  }
};

// AuthController.startRefreshTokenInterval = () => {
//   clearInterval(refreshTokenInterval);
//   refreshTokenInterval = setInterval(async () => {
//     try {
//       console.log("Refreshing token...");
//       await refreshToken();
//     } catch (error) {
//       console.error("Error refreshing token:", error);
//       AuthController.logout();
//     }
//   }, 7200000);
// };

AuthController.ResendEmail = async (email) => {
  try {
    const body = { email };
    const response = await api.post(API_ENDPOINTS.RESEND_REGISTER, body);

    if (response.status === 200) {
      toast.success("Verification email resent successfully.");
    } else {
      throw new Error("Failed to resend verification email.");
    }
  } catch (error) {
    handleError(error);
  }
};

AuthController.ResetPassword = async (id, token, newPassword) => {
  const body = { new_password: newPassword };
  try {
    const response = await api.post(
      API_ENDPOINTS.passwordResetConfirm(id, token),
      body
    );
    if (response.status !== 200) {
      throw new Error(
        response.data?.message || "Reset Password failed. Please try again."
      );
    }

    return response;
  } catch (error) {
    handleError(error);
  }
};

AuthController.FetchDashboard = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.DASHBOARD);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to fetch dashboard data.");
    }
  } catch (error) {
    handleError(error);
    return null;
  }
};

const addFCMToken = async (fcm_token) => {
  const body = {
    fcm_token,
  };

  try {
    let currentLanguage = localStorage.getItem("langId");
    if (currentLanguage === "US") {
      currentLanguage = "EN";
    }
    const response = await api.post(API_ENDPOINTS.UPDATE_FCM_TOKEN, body, {
      headers: {
        "Accept-Language": currentLanguage,
      },
    });

    if (response.status !== 200) {
      throw new Error(response.message || "FCM Token update failed. Please try again.");
    }

    return response.data;
  } catch (err) {
    handleError(err);
  }
};

const deleteFCMToken = async (fcm_token) => {
  try {
    let currentLanguage = localStorage.getItem("langId");
    if (currentLanguage === "US") {
      currentLanguage = "EN";
    }
    const response = await api.delete(API_ENDPOINTS.UPDATE_FCM_TOKEN, {
      data: { fcm_token },
      headers: {
        "Accept-Language": currentLanguage,
      },
    });

    if (response.status !== 200) {
      throw new Error(response.message || "FCM Token delete failed. Please try again.");
    }

    return response.data;
  } catch (err) {
    handleError(err);
  }
};

export default AuthController;
